import React, { useEffect, useState } from "react";
import { useOutlook } from "../hooks/useOutlook";
import { EmailContextResponse } from "../models/EmailModels";
import {
  getReadingAttachments,
  getReadingSubject,
  getReadingEmailAddress,
  getReadingEmailBody,
  getReadingEmailRestId,
} from "../taskpane";
import { useAnalyseEmail } from "../hooks/useAnalyseEmail";
import { Box, Card, CardContent, Typography } from "@mui/material";
import ActionWithAiContextGroup from "./ActionWithAiContextGroup";
import AiIcon from "../assets/icons/AiIcon";
import { useOrganisationConfigurations } from "../hooks/useOrganisationConfigurations";
import LoadingAiCard from "./LoadingAiCard/LoadingAiCard";

const ActionWithAiContext = () => {
  const { configurations } = useOrganisationConfigurations();
  const { analyseEmail } = useAnalyseEmail();
  const { isInReadMode } = useOutlook();
  const isShowContextEnabled = configurations?.isEmailContextEnabled ?? false;
  const [isLoadingContext, setIsLoadingContext] = useState(isInReadMode ? true : false);
  const [emailContext, setEmailContext] = useState<EmailContextResponse | null>({
    groups: [],
  });

  useEffect(() => {
    const getEmailContext = async () => {
      const emailId = (await getReadingEmailRestId()) ?? "";
      if (isInReadMode) {
        const sender = getReadingEmailAddress() ?? "";
        const emailContent = await getReadingEmailBody();
        const attachments = getReadingAttachments() ?? [];
        const subject = getReadingSubject() ?? "";
        const response = await analyseEmail({
          emailId: emailId,
          sender: sender,
          subject: subject,
          email: emailContent,
          attachments: attachments,
        });
        setEmailContext(response);
        setIsLoadingContext(false);
      }
    };

    if (isShowContextEnabled) {
      getEmailContext();
    }
  }, [isShowContextEnabled]);

  if (!isShowContextEnabled) {
    return null;
  }

  return (
    <>
      {isLoadingContext && emailContext?.groups && emailContext.groups.length === 0 && (
        <LoadingAiCard message="Attelas is analysing the email and will provide you with context related to the email." />
      )}
      {!isLoadingContext && emailContext?.groups && emailContext.groups.length > 0 && (
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Context
          </Typography>
          {emailContext?.groups.map((group) => (
            <ActionWithAiContextGroup key={group.type} title={group.type} values={group.values} />
          ))}
        </Box>
      )}
    </>
  );
};

export default ActionWithAiContext;
